export default {
  methods: {
    tranformDate2Epoch(data) {
      const utcDate = Date.UTC(data.getFullYear(), data.getMonth(), data.getDate(),
        data.getHours(), data.getMinutes(), data.getSeconds(), data.getMilliseconds())

      return new Date(utcDate).getTime()
    },

    firstDayOfMonth(data) {
      return new Date(data.getFullYear(), data.getMonth(), 1)
    },

    lastDayOfMonth(data) {
      return new Date(data.getFullYear(), data.getMonth() + 1, 0)
    },

    truncateTime(data) {
      data.setHours(12)
      data.setMinutes(0)
      data.setSeconds(0)
      data.setMilliseconds(0)
      return data
    },

    retornarMeses() {
      return [
        'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro',
      ]
    },

    retornarMesesEng() {
      return [
        'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',
      ]
    },
  },
}
